import { SlideDate, SlideDateFromJSON } from '@/api'

export interface UpdateSlideDaysRequest {
  branchCode: string
  year: string | number
  month: string | number
  days: SlideDate[]
}

export function UpdateSlideDaysRequestFromJSON(
  value: UpdateSlideDaysRequest
): any {
  return {
    branch_code: value.branchCode !== '' ? value.branchCode : undefined,
    year: value.year !== '' ? value.year : undefined,
    month: value.month !== '' ? value.month : undefined,
    days: value.days.map(function(value: SlideDate) {
      return SlideDateFromJSON(value)
    })
  }
}
